import { render, staticRenderFns } from "./EditBannerModal.vue?vue&type=template&id=5702f228"
import script from "./EditBannerModal.vue?vue&type=script&lang=js"
export * from "./EditBannerModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports